<template>
    <div>
        <div id="preloader" v-if="load" class="preloader"></div>
        <div v-if="step === 'first'" class="col-12 col-sm-6 p-0">
            <div class="registration-step">STEP 1 OF 2</div>
            <div class="wrapper-bids-title">
                <h2>Events Application</h2>
            </div>
            <p class="mt-4">You are applying for the following bid:</p>
        </div>
        <div v-if="step === 'second'" class="col-12 col-sm-6 p-0">
            <div class="registration-step">STEP 2 OF 2</div>
            <div class="wrapper-bids-title">
                <h2>Almost done</h2>
            </div>
            <p class="mt-4">
                You need to finish your registration in order to track your bid application:
            </p>
        </div>
        <div class="accordion-item js-preloader">
            <div class="header-artist-accordion row align-items-center">
                <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                    <p class="big-artist-text mb-0">{{ bid.start_date }}</p>
                    <p class="main-text">Date</p>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                    <p class="big-artist-text mb-0">${{ bid.budget }}</p>
                    <p class="main-text">Rate</p>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-3 word-break">
                    <div class="d-flex wrapper-keywords-pills">
                        <div
                            class="keywords-pills mb-2"
                            v-for="(keyword, index) in bid.array_keywords"
                            :key="index"
                        >
                            {{ keyword }}
                        </div>
                    </div>
                    <p class="main-text text-muted mt-2 mb-0">Sound</p>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                    <p class="big-artist-text mb-1">{{ bid.address }}</p>
                    <p class="main-text text-muted">Location</p>
                </div>
            </div>
            <div
                :id="'search-flush-collapse' + bid.id"
                class="accordion-collapse collapse"
                data-bs-parent="#search-accordion-flash"
            >
                <div class="accordion-body">
                    <div class="row mb-4">
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                            <p class="main-text-bold">Sound Equipment</p>
                            <p class="main-text">
                                <span v-if="bid.bring_equipment">
                                    Artist must bring own sound equipment
                                </span>
                                <span v-else>Artist mustn't bring own sound equipment</span>
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-8 mt-4">
                            <p class="main-text-bold">Special Riders/Extras</p>
                            <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                            <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                            <p class="main-text">Start Time</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="registration-form">
            <div class="d-flex flex-wrap">
                <div v-if="step === 'first'" class="d-flex flex-wrap">
                    <div class="form-wrapper p-1">
                        <div class="row pb-1">
                            <label for="first_name" class="main-text-bold py-3 px-0">
                                First name *
                            </label>
                            <input
                                required
                                placeholder="First name"
                                type="text"
                                id="first_name"
                                v-model="$v.firstName.$model"
                                @blur="$v.firstName.$touch"
                                :class="$v.firstName.$error ? 'is-invalid' : ''"
                                class="form-control border-50 py-3 ps-4 mb-2"
                            />
                            <p
                                class="error-form-message first-name-error"
                                v-if="firstNameError"
                            >
                                Field is required
                            </p>
                            <p class="error-form-message" v-if="firstNameValidate">
                                {{ firstNameValidate }}
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.firstName.$dirty && !$v.firstName.minLength"
                            >
                                Name must be more than 1 character
                            </p>
                        </div>

                        <div class="row pb-1">
                            <label for="last_name" class="main-text-bold py-3 px-0">
                                Last name *
                            </label>
                            <input
                                required
                                placeholder="Last name"
                                type="text"
                                name="last_name"
                                id="last_name"
                                v-model="$v.lastName.$model"
                                @blur="$v.lastName.$touch"
                                :class="$v.lastName.$error ? 'is-invalid' : ''"
                                class="form-control border-50 py-3 ps-4 mb-2"
                            />
                            <p class="error-form-message" v-if="lastNameError">
                                Field is required
                            </p>
                            <p class="error-form-message" v-if="lastNameValidate">
                                {{ lastNameValidate }}
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.lastName.$dirty && !$v.lastName.minLength"
                            >
                                Name must be more than 1 character
                            </p>
                        </div>

                        <div class="row pb-1">
                            <label for="email" class="main-text-bold py-3 px-0">Email *</label>
                            <input
                                required
                                placeholder="E-mail"
                                type="email"
                                name="email"
                                id="email"
                                @blur="$v.email.$touch"
                                v-model="$v.email.$model"
                                class="form-control border-50 py-3 ps-4 mb-2"
                            />
                            <p class="error-form-message" v-if="emailError">
                                Field is required
                            </p>
                            <p class="error-form-message" v-if="emailValidate">
                                {{ emailValidate }}
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.email.$dirty && !$v.email.email"
                            >
                                Enter email
                            </p>
                        </div>

                        <div class="row pb-1">
                            <label for="phone" class="main-text-bold py-3 px-0">
                                Phone Number *
                            </label>
                            <input
                                required
                                placeholder="Phone"
                                type="text"
                                v-mask="'###-###-####'"
                                name="phone"
                                id="phone"
                                v-model="$v.phone.$model"
                                class="form-control phone border-50 py-3 ps-4 mb-2"
                            />
                            <p class="error-form-message" v-if="phoneError">
                                Field is required
                            </p>
                            <p class="error-form-message" v-if="phoneValidate">
                                {{ phoneValidate }}
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.phone.$dirty && !$v.phone.required"
                            >
                                Required field
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.phone.$dirty && !$v.phone.minLength"
                            >
                                Please enter exactly 10 digits
                            </p>
                        </div>

                        <div class="row pb-1">
                            <label class="main-text-bold py-3 px-0">Social Media</label>
                            <div class="social-buttons">
                                <div class="position-relative">
                                    <div v-if="checkFacebookLink" class="check-links">
                                        <i class="down"></i>
                                    </div>
                                    <div
                                        @click="showFacebookField"
                                        :class="{
                                            'social-button-active': linkMode === 'facebook'
                                        }"
                                        class="social-button facebook-btn"
                                    >
                                        <div class="facebook-icon"></div>
                                    </div>
                                    <p class="link-name">Facebook</p>
                                </div>
                                <div class="position-relative">
                                    <div v-if="checkTwitterLink" class="check-links">
                                        <i class="down"></i>
                                    </div>
                                    <div
                                        @click="showTwitterField"
                                        :class="{
                                            'social-button-active': linkMode === 'twitter'
                                        }"
                                        class="social-button twitter-btn"
                                    >
                                        <div class="twitter-icon"></div>
                                    </div>
                                    <p class="link-name">Twitter</p>
                                </div>
                                <div class="position-relative">
                                    <div v-if="checkInstagramLink" class="check-links">
                                        <i class="down"></i>
                                    </div>
                                    <div
                                        @click="showInstargamField"
                                        :class="{
                                            'social-button-active': linkMode === 'instagram'
                                        }"
                                        class="social-button instagram-btn"
                                    >
                                        <div class="instagram-icon"></div>
                                    </div>
                                    <p class="link-name">Instagram</p>
                                </div>
                                <div class="position-relative">
                                    <div v-if="checkTikTokLink" class="check-links">
                                        <i class="down"></i>
                                    </div>
                                    <div
                                        @click="showTikTokField"
                                        :class="{
                                            'social-button-active': linkMode === 'tiktok'
                                        }"
                                        class="social-button tiktok-btn"
                                    >
                                        <div class="tiktok-icon"></div>
                                    </div>
                                    <p class="link-name">TikTok</p>
                                </div>
                                <div class="position-relative">
                                    <div v-if="checkYouTubeLink" class="check-links">
                                        <i class="down"></i>
                                    </div>
                                    <div
                                        @click="showYouTubeField"
                                        :class="{
                                            'social-button-active': linkMode === 'youtube'
                                        }"
                                        class="social-button youtube-btn"
                                    >
                                        <div class="youtube-icon"></div>
                                    </div>
                                    <p class="link-name">Youtube</p>
                                </div>
                            </div>
                            <div v-if="linkMode === 'facebook'" class="row pb-1 mt-3">
                                <label for="facebook_url" class="main-text-bold pt-4 pb-4 px-0"
                                    >Facebook profile URL</label
                                >
                                <input
                                    v-model="$v.socialLinks.facebook.$model"
                                    placeholder="facebook.com/yourprofilename"
                                    name="facebook"
                                    id="facebook_url"
                                    class="form-control facebook_url border-50 pt-4 pb-4 ps-4 mb-2"
                                />
                                <p
                                    class="error-form-message"
                                    v-if="$v.socialLinks.facebook.$dirty && !checkFacebookLink"
                                >
                                    Please enter a valid url
                                </p>
                            </div>
                            <div v-if="linkMode === 'twitter'" class="row pb-1 mt-3">
                                <label for="twitter_url" class="main-text-bold pt-4 pb-4 px-0"
                                    >Twitter profile URL</label
                                >
                                <input
                                    v-model="$v.socialLinks.twitter.$model"
                                    placeholder="twitter.com/yourprofilename"
                                    name="twitter"
                                    id="twitter_url"
                                    class="form-control twitter_url border-50 pt-4 pb-4 ps-4 mb-2"
                                />
                                <p
                                    class="error-form-message"
                                    v-if="$v.socialLinks.twitter.$dirty && !checkTwitterLink"
                                >
                                    Please enter a valid url
                                </p>
                            </div>
                            <div v-if="linkMode === 'instagram'" class="row pb-1 mt-3">
                                <label
                                    for="instagram_url"
                                    class="main-text-bold pt-4 pb-4 px-0"
                                    >Instagram profile URL</label
                                >
                                <input
                                    v-model="$v.socialLinks.instagram.$model"
                                    placeholder="instagram.com/yourprofilename"
                                    name="instagram"
                                    id="instagram_url"
                                    class="form-control instagram_url border-50 pt-4 pb-4 ps-4 mb-2"
                                />
                                <p
                                    class="error-form-message"
                                    v-if="
                                        $v.socialLinks.instagram.$dirty && !checkInstagramLink
                                    "
                                >
                                    Please enter a valid url
                                </p>
                            </div>
                            <div v-if="linkMode === 'tiktok'" class="row pb-1 mt-3">
                                <label for="tiktok_url" class="main-text-bold pt-4 pb-4 px-0"
                                    >TiKTok profile URL</label
                                >
                                <input
                                    v-model="$v.socialLinks.tiktok.$model"
                                    placeholder="tiktok.com/yourprofilename"
                                    name="tiktok"
                                    id="tiktok_url"
                                    class="form-control tiktok_url border-50 pt-4 pb-4 ps-4 mb-2"
                                />
                                <p
                                    class="error-form-message"
                                    v-if="$v.socialLinks.tiktok.$dirty && !checkTikTokLink"
                                >
                                    Please enter a valid url
                                </p>
                            </div>
                            <div v-if="linkMode === 'youtube'" class="row pb-1 mt-3">
                                <label for="youtube_url" class="main-text-bold pt-4 pb-4 px-0"
                                    >YouTube profile URL</label
                                >
                                <input
                                    v-model="$v.socialLinks.youtube.$model"
                                    placeholder="youtube.com/yourprofilename"
                                    name="youtube"
                                    id="youtube_url"
                                    class="form-control youtube_url border-50 pt-4 pb-4 ps-4 mb-2"
                                />
                                <p
                                    class="error-form-message"
                                    v-if="$v.socialLinks.youtube.$dirty && !checkYouTubeLink"
                                >
                                    Please enter a valid url
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="right-form">
                        <div class="row pb-1">
                            <label for="last_name" class="main-text-bold py-3 px-0"
                                >Artist/Band Name *</label
                            >
                            <input
                                required
                                placeholder="Artist/Band Name"
                                type="text"
                                name="band_name"
                                id="Artist/Band_Name"
                                v-model="$v.bandName.$model"
                                @blur="$v.bandName.$touch"
                                class="form-control border-50 py-3 ps-4 mb-2"
                            />
                            <p class="error-form-message" v-if="bandNameError">
                                Field is required
                            </p>
                            <p class="error-form-message" v-if="bandNameValidate">
                                {{ bandNameValidate }}
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.bandName.$dirty && !$v.bandName.minLength"
                            >
                                Name must be more than 1 character
                            </p>
                        </div>

                        <div class="row pb-1">
                            <label for="last_name" class="main-text-bold py-3 px-0"
                                >Quick Bio *</label
                            >
                            <textarea
                                required
                                name="quick_bio"
                                id="quick_bio"
                                cols="30"
                                rows="10"
                                placeholder="Enter short bio..."
                                v-model="$v.quickBio.$model"
                                @blur="$v.quickBio.$touch"
                                class="form-control border-50 py-3 ps-4 mb-2"
                            >
                            </textarea>
                            <p class="error-form-message" v-if="quickBioError">
                                Field is required
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.quickBio.$dirty && !$v.quickBio.required"
                            >
                                Field is required
                            </p>
                            <p
                                class="error-form-message"
                                v-if="$v.quickBio.$dirty && !$v.quickBio.minLength"
                            >
                                Name must be more than 1 character
                            </p>
                        </div>

                        <div class="col-12 col-lg-6 w-100">
                            <div class="mb-3">
                                <label class="form-label">Location *</label>
                                <input
                                    type="text"
                                    required
                                    @blur="$v.location.$touch"
                                    v-model.trim="$v.location.$model"
                                    placeholder="Location"
                                    ref="location"
                                    name="location"
                                    id="address-artist-location"
                                    :class="{
                                        'is-invalid': errors.location,
                                        'is-invalid': errors.lat
                                    }"
                                    class="group-input form-control border-50 py-4"
                                />
                                <p class="error-form-message" v-if="errorlocation">
                                    Field is required
                                </p>
                                <p
                                    class="error-form-message"
                                    v-if="$v.location.$dirty && !$v.location.required"
                                >
                                    Field is required
                                </p>
                                <p
                                    class="error-form-message"
                                    v-if="$v.location.$dirty && !$v.location.minLength"
                                >
                                    Name must be more than 1 character
                                </p>
                                <span
                                    class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.location"
                                >
                                    <strong>{{ errors.location[0] }}</strong>
                                </span>
                                <span
                                    class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.lat && !errors.location"
                                >
                                    <strong>{{ errors.lat[0] }}</strong>
                                </span>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 position-relative">
                            <div class="mb-2 profile-edit-input-group">
                                <div class="col-12 validation-input-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label
                                                for="travel_radius"
                                                class="main-text-bold pb-3 pt-3 px-0"
                                                >Travel Radius *</label
                                            >
                                            <div class="custom-number-input-wrapper">
                                                <div
                                                    class="form-input-border input-group border-50"
                                                >
                                                    <div
                                                        class="col-2 d-flex justify-content-center align-items-center"
                                                    >
                                                        <span class="main-text-bold">Mi</span>
                                                    </div>
                                                    <div class="col-10">
                                                        <div
                                                            class="custom-number-input-wrapper"
                                                        >
                                                            <input
                                                                placeholder="Travel Radius in miles"
                                                                type="number"
                                                                min="1"
                                                                max="10000"
                                                                name="travel_radius"
                                                                id="travel_radius"
                                                                v-model="
                                                                    $v.travelRadius.$model
                                                                "
                                                                @blur="$v.travelRadius.$touch"
                                                                require
                                                                class="w-100 custom-arrows first-hour-rate-input group-input border-50 py-4"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p
                                                class="error-form-message"
                                                v-if="
                                                    $v.travelRadius.$dirty &&
                                                    !$v.travelRadius.required
                                                "
                                            >
                                                Field is required
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="row number-input-controls-container d-flex justify-content-center"
                            >
                                <div class="col-2 d-flex input-controls px-4">
                                    <div class="input-controls-wrapper row mx-3 py-3">
                                        <div
                                            id="hourUp"
                                            class="js-number-input-upper js-recurring-input custom-number-input-upper-arrow"
                                            @click="hourUp"
                                        >
                                            <img
                                                src="images/icons/number-input-upper.png"
                                                alt="increase value"
                                            />
                                        </div>
                                        <div
                                            id="hourDown"
                                            class="js-number-input-lower js-recurring-input custom-number-input-lower-arrow"
                                            @click="hourDown"
                                        >
                                            <img
                                                src="images/icons/number-input-lower.png"
                                                alt="decrease value"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="d-flex justify-content-between mb-5 flex-wrap upload-block"
                        >
                            <div>
                                <p class="upload-title">Upload Profile Picture / Video *</p>
                                <div :class="{ 'error-message': errorImage }">
                                    <div
                                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                                        @dragenter="dragging = true"
                                        @dragleave="dragging = false"
                                    >
                                        <div
                                            class="dropZone-info onchange-image"
                                            @drag="onChangeImage"
                                        >
                                            <span
                                                class="fa fa-cloud-upload dropZone-title"
                                            ></span>
                                            <span class="dropZone-title">Click to upload</span>
                                            <span>or drag and drop</span>
                                            <div class="dropZone-upload-limit-info">
                                                <div>Maximum total file size: 100 MB</div>
                                                <div
                                                    :class="{
                                                        'warning-text': checkImageSize > 100
                                                    }"
                                                >
                                                    Loaded {{ checkImageSize }}/100 MB
                                                </div>
                                            </div>
                                        </div>
                                        <input
                                            type="file"
                                            name="file_image"
                                            multiple
                                            @change="onChangeImage"
                                        />
                                    </div>
                                </div>
                                <p class="error-form-message" v-if="checkImageType">
                                    Please upload image or video
                                </p>
                                <p class="error-form-message" v-if="checkImageSize > 100">
                                    Total upload size exceeded
                                </p>
                                <p class="error-form-message" v-if="errorImage">
                                    Required field
                                </p>
                                <div
                                    v-if="fileImage.length >= 1"
                                    :class="{ 'more-images': fileImage.length > 3 }"
                                >
                                    <div
                                        v-for="(imageFile, index) in fileImage"
                                        :key="index"
                                        class="uploadedFile-info position-relative"
                                    >
                                        <p
                                            @click="removeFileImage(imageFile.name)"
                                            class="remove-file remove-image"
                                        >
                                            x
                                        </p>
                                        <div class="file-name">{{ imageFile.name }}</div>
                                        <div>
                                            {{ (imageFile.size / 1024 / 1024).toFixed(2) }} MB
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="fileImage.length > 3"
                                    class="d-flex justify-content-center mt-2"
                                >
                                    <i class="down"></i>
                                </div>
                            </div>
                            <div>
                                <p class="upload-title">Upload Music Sample *</p>
                                <div :class="{ 'error-message': errorMusic }">
                                    <div
                                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                                        @dragenter="dragging = true"
                                        @dragleave="dragging = false"
                                    >
                                        <div
                                            class="dropZone-info onchange-music"
                                            @drag="onChangeMusic"
                                        >
                                            <span
                                                class="fa fa-cloud-upload dropZone-title"
                                            ></span>
                                            <span class="dropZone-title">Click to upload</span>
                                            <span>or drag and drop</span>
                                            <div class="dropZone-upload-limit-info">
                                                <div>Maximum file size: 50 MB</div>
                                                <div
                                                    :class="{
                                                        'warning-text': checkAudioSize > 50
                                                    }"
                                                >
                                                    Loaded {{ checkAudioSize }}/50 MB
                                                </div>
                                            </div>
                                        </div>
                                        <input
                                            type="file"
                                            multiple="multiple"
                                            @change="onChangeMusic"
                                        />
                                    </div>
                                </div>
                                <p class="error-form-message" v-if="checkMusicType">
                                    Please upload audio
                                </p>
                                <p class="error-form-message" v-if="checkAudioSize > 50">
                                    Total upload size exceeded
                                </p>
                                <p class="error-form-message" v-if="errorMusic">
                                    Required field
                                </p>
                                <div
                                    v-if="fileMusic.length >= 1"
                                    :class="{ 'more-images': fileMusic.length > 3 }"
                                >
                                    <div
                                        v-for="(imageMusic, index) in fileMusic"
                                        :key="index"
                                        class="uploadedFile-info position-relative"
                                    >
                                        <p
                                            @click="removeFileMusic(imageMusic.name)"
                                            class="remove-file"
                                        >
                                            x
                                        </p>
                                        <div class="file-name">{{ imageMusic.name }}</div>
                                        <div>
                                            {{ (imageMusic.size / 1024 / 1024).toFixed(2) }} MB
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="fileMusic.length > 3"
                                    class="d-flex justify-content-center mt-2"
                                >
                                    <i class="down"></i>
                                </div>
                            </div>
                        </div>

                        <div class="row pt-1 pb-4">
                            <button
                                @click="goToSecondStep"
                                class="btn btn-step-to button-text bg-purple text-white btn-shadow border-100 py-3"
                                style="height: 63px"
                            >
                                Apply for bid
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="step === 'second'" class="password-step">
                    <div class="row pb-1">
                        <label for="password" class="main-text-bold py-3 px-0"
                            >Password *</label
                        >
                        <div class="position-relative">
                            <input
                                required
                                placeholder="Password"
                                type="password"
                                name="password"
                                id="password"
                                @blur="$v.password.$touch"
                                v-model.trim="$v.password.$model"
                                class="form-control border-50 py-3 ps-4 mb-2"
                                autocomplete="new-password"
                            />
                            <div
                                class="error"
                                v-if="$v.password.$dirty && !$v.password.required"
                            >
                                Password is required.
                            </div>
                            <div
                                class="error"
                                v-if="$v.password.$dirty && !$v.password.minLength"
                            >
                                Password must have at least
                                {{ $v.password.$params.minLength.min }} letters.
                            </div>
                        </div>
                    </div>
                    <div class="row pb-3 position-relative">
                        <label for="password_confirmation" class="main-text-bold py-3 px-0"
                            >Confirm Password *</label
                        >
                        <div class="position-relative">
                            <input
                                required
                                placeholder="Confirm Password"
                                type="password"
                                name="password_confirmation"
                                id="password_confirmation"
                                v-model.trim="$v.repeatPassword.$model"
                                class="form-control border-50 py-3 ps-4 mb-2"
                                autocomplete="new-password"
                            />
                            <div class="error" v-if="!$v.repeatPassword.sameAsPassword">
                                Passwords must be identical.
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-end">
                        <input type="radio" required />
                        <p class="agree-info">
                            By selecting the button below, I agree to Hedlyner's Terms of
                            Service, Payment Terms, Refunds and Cancellation Policy, Dispute
                            Resolution Policy and Off-Platform Policy.
                        </p>
                    </div>
                    <div class="row pt-1 pb-4">
                        <button
                            class="btn button-text bg-purple text-white btn-shadow border-100 py-3 register-btn"
                            style="height: 63px"
                            @click="registerArtist()"
                        >
                            Register
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {
        required,
        minLength,
        email,
        sameAs,
        numeric,
        maxLength
    } from 'vuelidate/lib/validators'

    export default {
        name: 'index-guest-sing-up',
        validations: {
            firstName: { required, minLength: minLength(2) },
            lastName: { required, minLength: minLength(2) },
            email: { required, email },
            phone: { required, numeric, minLength: minLength(12) },
            socialLinks: {
                facebook: { minLength: minLength(13) },
                twitter: { minLength: minLength(12) },
                instagram: { minLength: minLength(14) },
                tiktok: { minLength: minLength(11) },
                youtube: { minLength: minLength(12) }
            },
            bandName: { required, minLength: minLength(2) },
            quickBio: { required, minLength: minLength(3), maxLength: maxLength(225) },
            travelRadius: { required },
            location: { required, minLength: minLength(2) },
            password: { required, minLength: minLength(6) },
            repeatPassword: { sameAsPassword: sameAs('password') }
        },
        data() {
            return {
                url: '/events',
                registrationUserUrl: '/register-new-bid-user',
                setPassword: '/set-new-bid-user-password',
                bid: '',
                bidId: '',
                userId: '',
                open: false,
                linkMode: 'facebook',
                step: 'first',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                bandName: '',
                password: '',
                quickBio: '',
                repeatPassword: '',
                fileImageName: '',
                fileImage: [],
                fileMusic: [],
                errorImage: false,
                errorMusic: false,
                load: false,
                dragging: false,
                emailValidate: false,
                phoneValidate: false,
                bandNameValidate: false,
                firstNameValidate: false,
                lastNameValidate: false,
                checkImageType: false,
                checkMusicType: false,
                travelRadius: 1,
                location: null,
                errorlocation: false,
                firstNameError: false,
                lastNameError: false,
                emailError: false,
                phoneError: false,
                bandNameError: false,
                quickBioError: false,
                lat: null,
                lon: null,
                errors: {},
                socialLinks: {
                    facebook: '',
                    twitter: '',
                    instagram: '',
                    tiktok: '',
                    youtube: ''
                },
                datas: {},
                sizeImage: [],
                sizeAudio: []
            }
        },
        methods: {
            async getBid(bid) {
                const response = await axios.get(
                    this.url + '/new-and-proceed-list-guest/' + bid
                )
                this.bid = response.data.data
            },

            getIcon() {
                return '/images/icons/'
            },

            showFacebookField() {
                this.linkMode = 'facebook'
            },

            showTwitterField() {
                this.linkMode = 'twitter'
            },

            showInstargamField() {
                this.linkMode = 'instagram'
            },

            showTikTokField() {
                this.linkMode = 'tiktok'
            },

            showYouTubeField() {
                this.linkMode = 'youtube'
            },

            async goToSecondStep() {
                try {
                    this.load = true
                    if (
                        this.fileImage.length &&
                        this.fileMusic.length &&
                        this.location !== null
                    ) {
                        const config = {
                            headers: { 'content-type': 'multipart/form-data' }
                        }
                        let formData = new FormData()
                        formData.append('first_name', this.firstName)
                        formData.append('last_name', this.lastName)
                        formData.append('email', this.email)
                        formData.append('phone_number', this.phone)
                        if (this.socialLinks.facebook === '') delete this.socialLinks.facebook
                        if (this.socialLinks.twitter === '') delete this.socialLinks.twitter
                        if (this.socialLinks.instagram === '')
                            delete this.socialLinks.instagram
                        if (this.socialLinks.tiktok === '') delete this.socialLinks.tiktok
                        if (this.socialLinks.youtube === '') delete this.socialLinks.youtube
                        formData.append('social_links', JSON.stringify(this.socialLinks))
                        formData.append('bandName', this.bandName)
                        formData.append('short_biography', this.quickBio)
                        formData.append('home_location', this.location)
                        formData.append('lat', this.lat)
                        formData.append('lon', this.lon)
                        formData.append('travel_radius', this.travelRadius)
                        for (let i = 0; i < this.fileImage.length; i++) {
                            formData.append('files[]', this.fileImage[i])
                        }
                        for (let i = 0; i < this.fileMusic.length; i++) {
                            formData.append('audios[]', this.fileMusic[i])
                        }
                        const response = await axios.post(
                            this.registrationUserUrl,
                            formData,
                            config
                        )
                        this.load = false
                        this.step = 'second'
                        this.userId = response.data.userId
                    } else {
                        this.load = false
                        this.errorImage = true
                        this.errorMusic = true
                        this.errorlocation = true
                        this.firstName
                            ? (this.firstNameError = false)
                            : (this.firstNameError = true)
                        this.lastName
                            ? (this.lastNameError = false)
                            : (this.lastNameError = true)
                        this.email ? (this.emailError = false) : (this.emailError = true)
                        this.phone ? (this.phoneError = false) : (this.phoneError = true)
                        this.bandName
                            ? (this.bandNameError = false)
                            : (this.bandNameError = true)
                        this.quickBio
                            ? (this.quickBioError = false)
                            : (this.quickBioError = true)
                    }
                } catch (error) {
                    this.load = false
                    if (error.response.data.errors.email)
                        this.emailValidate = error.response.data.errors.email[0]
                    if (error.response.data.errors.phone_number)
                        this.phoneValidate = error.response.data.errors.phone_number[0]
                    if (error.response.data.errors.bandName)
                        this.bandNameValidate = error.response.data.errors.bandName[0]
                    if (error.response.data.errors.first_name)
                        this.firstNameValidate = error.response.data.errors.first_name[0]
                    if (error.response.data.errors.last_name)
                        this.lastNameValidate = error.response.data.errors.last_name[0]
                    if (error.response.data.errors.quick_bio)
                        this.lastNameValidate = error.response.data.errors.quick_bio[0]
                }
            },

            async registerArtist() {
                const response = await axios.post(this.setPassword, {
                    userId: this.userId,
                    password: this.password,
                    bid: this.bid,
                    data: this.datas
                })

                if (response.status === 200) {
                    window.open('/profile', '_self')
                }

                if (response.status === 500) console.log(this.user)
            },

            onChangeImage(e) {
                let regex = /\.(jpg|jpeg|png|mp4|x-m4v|webm|ogg)$/i
                let tgt = e.target,
                    files = tgt.files,
                    maxSize = 100000000
                if (files.length >= 1 || files.length <= 3) {
                    for (let imageFile in files) {
                        if (
                            files[imageFile].name.search(regex) != -1 &&
                            files[imageFile].size <= maxSize
                        ) {
                            this.fileImage.push(files[imageFile])
                            this.sizeImage.push(files[imageFile].size)
                            this.checkImageType = false
                            if (this.checkImageSize > 100) {
                                this.dragging = false
                                return
                            }
                        } else {
                            this.checkImageType = true
                            this.dragging = false
                            return
                        }
                    }
                }
            },

            onChangeMusic(e) {
                let regex = /\.(mp3|audio|au|snd|ram)$/i
                let tgt = e.target,
                    files = tgt.files,
                    maxSize = 50000000
                if (files.length > 1 || files.length <= 3) {
                    for (let audioFile in files) {
                        if (
                            files[audioFile].name.search(regex) != -1 &&
                            files[audioFile].size <= maxSize
                        ) {
                            this.fileMusic.push(files[audioFile])
                            this.sizeAudio.push(files[audioFile].size)
                            this.checkMusicType = false
                            if (this.checkAudioSize > 50) {
                                this.dragging = false
                                return
                            }
                        } else {
                            this.checkMusicType = true
                            this.dragging = false
                            return
                        }
                    }
                }
            },

            removeFileImage(name) {
                const indexFile = this.fileImage.findIndex((file) => file.name === name)
                this.fileImage.splice(indexFile, 1)
            },

            removeAllFileImage() {
                this.fileImage = []
            },

            removeAllFileMusic() {
                this.fileMusic = []
            },

            removeFileMusic(name) {
                const indexFile = this.fileMusic.findIndex((file) => file.name === name)
                this.fileMusic.splice(indexFile, 1)
            },

            hourUp() {
                if (this.travelRadius >= 0 && this.travelRadius <= 10000) {
                    this.travelRadius++
                }
            },

            hourDown() {
                if (this.travelRadius >= 0 && this.travelRadius <= 10000) {
                    this.travelRadius--
                }
            },

            initPlaceApi() {
                let vm = this
                let placeElement = this.$refs.location
                if (placeElement) {
                    let autocomplete = new google.maps.places.Autocomplete(placeElement, {
                        types: ['(regions)'],
                        componentRestrictions: { country: 'us' }
                    })
                    autocomplete.addListener('place_changed', function () {
                        let place = autocomplete.getPlace()
                        let latitude = place.geometry.location.lat()
                        let longitude = place.geometry.location.lng()
                        vm.location = place.formatted_address
                        vm.lat = latitude
                        vm.lon = longitude
                    })
                }
            }
        },
        computed: {
            checkImageSize() {
                return this.sizeImage.length >= 1
                    ? (this.sizeImage.reduce((a, b) => b + a) / 1024 / 1024).toFixed(2)
                    : 0
            },
            checkAudioSize() {
                return this.sizeAudio.length >= 1
                    ? (this.sizeAudio.reduce((a, b) => b + a) / 1024 / 1024).toFixed(2)
                    : 0
            },
            checkFacebookLink() {
                return (
                    this.socialLinks.facebook.includes('facebook.com/') ||
                    this.socialLinks.facebook.includes('https://facebook.com/')
                )
            },
            checkTwitterLink() {
                return (
                    this.socialLinks.twitter.includes('twitter.com/') ||
                    this.socialLinks.twitter.includes('https://twitter.com/')
                )
            },
            checkInstagramLink() {
                return (
                    this.socialLinks.instagram.includes('instagram.com/') ||
                    this.socialLinks.instagram.includes('https://instagram.com/')
                )
            },
            checkTikTokLink() {
                return (
                    this.socialLinks.tiktok.includes('tiktok.com/') ||
                    this.socialLinks.tiktok.includes('https://tiktok.com/')
                )
            },
            checkYouTubeLink() {
                return (
                    this.socialLinks.youtube.includes('youtube.com/') ||
                    this.socialLinks.youtube.includes('https://youtube.com/')
                )
            }
        },
        async mounted() {
            this.bidId = localStorage.getItem('bidId')
            this.datas = localStorage.getItem('data')
            await this.getBid(Number(this.bidId))
            setTimeout(() => {
                this.initPlaceApi()
            }, 700)
        },
        destroyed() {
            localStorage.removeItem('bidId')
            localStorage.removeItem('data')
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .registration-form {
        padding-top: 60px;
    }
    .accordion-item {
        background: rgba(27, 13, 41, 0.06);
        padding: 20px 50px;
    }

    .big-artist-text {
        font-family: helveticabold;
        font-style: normal;
        font-weight: 700;
        font-size: 26px;
        letter-spacing: 0.1em;
        color: #49306b;
    }
    .keywords-pills {
        border: 1px solid #49306b;
        box-sizing: border-box;
        border-radius: 20px;
        padding: 5px 16px;
        color: #49306b;
        margin-right: 10px;
        font-size: 16px;
        max-width: 60%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .social-buttons {
        display: flex;
    }

    .social-button {
        border-radius: 50%;
        background: rgba(73, 48, 107, 0.24);
        margin-left: 10px;
        width: 60px;
        height: 60px;
        position: relative;
        -webkit-transition: 1s;
        -moz-transition: 1s;
        -ms-transition: 1s;
        -o-transition: 1s;
        transition: 1s;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    .link-name {
        text-align: center;
    }
    .facebook-icon {
        background-image: url('/images/2021_Facebook_icon.svg.png');
        background-repeat: no-repeat;
        background-size: contain;
        height: 28px;
        width: 28px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .twitter-icon {
        background-image: url('/images/icons8-твиттер-48.png');
        background-repeat: no-repeat;
        background-size: contain;
        height: 28px;
        width: 28px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .instagram-icon {
        background-image: url('/images/Instagram_icon.png.webp');
        background-repeat: no-repeat;
        background-size: contain;
        height: 28px;
        width: 28px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .tiktok-icon {
        background-image: url('/images/icons/social/tiktok.png');
        background-repeat: no-repeat;
        background-size: contain;
        height: 28px;
        width: 28px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .youtube-icon {
        background-image: url('/images/1384060.png');
        background-repeat: no-repeat;
        background-size: contain;
        height: 28px;
        width: 28px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .social-button:hover {
        -webkit-transition: 1s;
        -moz-transition: 1s;
        -ms-transition: 1s;
        -o-transition: 1s;
        transition: 1s;
        -webkit-filter: grayscale(0%);
        filter: grayscale(0%);
    }

    .social-button-active {
        -webkit-transition: 1s;
        -moz-transition: 1s;
        -ms-transition: 1s;
        -o-transition: 1s;
        transition: 1s;
        -webkit-filter: grayscale(0%);
        filter: grayscale(0%);
    }

    .form-wrapper {
        display: flex;
        flex-direction: column;
        flex: 50%;
    }

    .form-control {
        max-width: 80%;
    }

    .upload-container {
        min-width: 300px;
        min-height: 160px;
        border: 1px dashed #49306b;
        border-radius: 4px;
        background: rgba(73, 48, 107, 0.06);
    }

    .agree-info {
        max-width: 600px;
        max-height: 80px;
        margin-left: 15px;
    }

    .password-step {
        max-width: 60%;
    }

    .error-form-message {
        color: #ed3c0d;
    }

    @media (max-width: 1200px) {
        .form-wrapper {
            flex-wrap: unset;
        }

        .form-control {
            max-width: 100%;
        }

        .password-step {
            max-width: 100%;
        }
    }

    .dropZone {
        background: rgba(73, 48, 107, 0.06);
        border: 1px dashed #49306b;
        height: 160px;
        position: relative;
        min-width: 300px;
    }

    .dropZone:hover {
        border: 1px solid #49306b;
    }

    .dropZone:hover .dropZone-title {
        color: #49306b;
    }

    .dropZone-info {
        color: #a8a8a8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .dropZone-title {
        color: #787878;
    }

    .dropZone input {
        position: absolute;
        cursor: pointer;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100% !important;
        opacity: 0;
    }

    .dropZone-upload-limit-info {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .dropZone-over {
        background: #5c5c5c;
        opacity: 0.8;
    }

    .dropZone-uploaded {
        height: 160px;
        min-width: 300px;
        position: relative;
        border: 2px dashed #eee;
        margin-top: 37px;
    }

    .dropZone-uploaded-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #a8a8a8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .removeFile {
        width: 200px;
    }
    .uploadedFile-info {
        border: 1px solid #49306b;
        border-radius: 4px;
        max-width: 300px;
        margin-top: 12px;
        padding: 5px 15px;
    }

    .remove-file {
        position: absolute;
        right: 6px;
        bottom: 18px;
        cursor: pointer;
    }

    .error-message {
        border: 1px dashed #ed3c0d;
    }

    .number-input-controls-container {
        position: absolute;
        right: 7px;
        top: 58px;
        z-index: 2;
    }

    .wrapper-keywords-pills {
        flex-wrap: wrap;
        overflow-x: auto;
        max-height: 150px;
    }
    .file-name {
        width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .upload-title {
        font-weight: 700;
        font-size: 18px;
        margin-top: 50px;
    }

    .right-form {
        flex: 50%;
    }

    .more-images {
        max-height: 220px;
        overflow: auto;
    }

    .more-images::-webkit-scrollbar {
        display: none;
    }

    i {
        border: solid #49306b;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
    }

    .down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
    }

    .warning-text {
        color: #f00;
    }

    .wrapper-keywords-pills::-webkit-scrollbar {
        display: none;
    }
    .check-links {
        position: absolute;
        right: 0px;
        bottom: 93px;
    }

    @media (max-width: 1200px) {
        .upload-block {
            justify-content: center !important;
        }
    }
</style>
